import FormCheckbox from '@Components/Form/FormCheckBox';
import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { INFO_CATEGORY_RISK_RELATED } from '@Domains/RiskRelated';
import { Box, FormGroup, Typography } from '@mui/material';
import { mapRiskByGroups } from './utils';
import { useFormContext } from 'react-hook-form';
import { OTHER_RISKS_ID } from './ModalRiskRelatedCheckboxList';

export type RiskByGroup = {
  infoCategory: IInfoCategoryMasterData['infoCategory'];
  value: INFO_CATEGORY_RISK_RELATED;
  label: string;
  data: IInfoCategoryMasterData[];
};

type RiskRelatedCheckboxListProps = {
  filteredRisks: IInfoCategoryMasterData[];
};

const RiskRelatedCheckboxList = ({
  filteredRisks = [],
}: RiskRelatedCheckboxListProps) => {
  const { setValue } = useFormContext();

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    riskId: number
  ) => {
    const isOther = Object.values(OTHER_RISKS_ID).includes(riskId);

    if (isOther) {
      setValue(`riskId${riskId}.nameTh`, '');
      setValue(`riskId${riskId}.nameEn`, '');
    }
    setValue(`riskId${riskId}.infoCategoryMasterDataId`, riskId);
  };

  if (filteredRisks.length === 0) {
    return (
      <Box
        p={1}
        border="1px solid rgba(0, 0, 0, 0.12)"
        borderTop="none"
        sx={{
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
      >
        <Typography textAlign={'center'}>ไม่มีรายการ</Typography>
      </Box>
    );
  }

  const filterByGroups = mapRiskByGroups(filteredRisks);

  return (
    <Box
      maxHeight="250px"
      p={1}
      border="1px solid rgba(0, 0, 0, 0.12)"
      borderTop="none"
      sx={{
        overflowY: 'auto',
        overflowX: 'hidden',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      }}
    >
      {filterByGroups.map((group) => {
        if (group.data.length === 0) return null;
        return (
          <Box key={group.value}>
            <Typography my={1} fontWeight={700} fontSize={16}>
              {group.label}
            </Typography>
            <FormGroup>
              {group.data.map((risk) => (
                <FormCheckbox
                  key={risk.id}
                  name={`riskId${risk.id}.checked`}
                  label={risk.nameTh}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleCheckboxChange(event, risk.id);
                  }}
                />
              ))}
            </FormGroup>
          </Box>
        );
      })}
    </Box>
  );
};

export default RiskRelatedCheckboxList;
